import React from 'react'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'

import getLanguageIcon from '../../../utilities/language/getLanguageIcon'

if (process.env.REACT_APP_COMPONENT_LANGUAGE_TOGGLE_LAYOUT === 'icon-menu') {
	require('../../../styles/css/components/language/bk-flow-language-toggle-icon-menu.css')
}

const BkFlowLanguageToggleDefault = props => {
	const {
		currentLanguage,
		languageMenuEvent,
		languageOptions,
		languageMenuVisible
	} = props

	const languageIcon = getLanguageIcon(currentLanguage)

	return (
		<div className="bk-flow__language">
			<button
				className="bk-flow__language-toggle"
				onClick={() => languageMenuEvent()}
			>
				<img src={languageIcon} alt={currentLanguage} />
			</button>

			{ languageMenuVisible &&
				<ClickAwayListener onClickAway={ languageMenuEvent }>
					<div className="bk-flow__language-menu">
						{ languageOptions }
					</div>
				</ClickAwayListener>
			}
		</div>
	)
}


export default BkFlowLanguageToggleDefault


// WEBPACK FOOTER //
// ./src/components/language/layouts/BkFlowLanguageToggleIconMenu.js